import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import CmsPage from 'models/CmsPage';
import CompanySite from 'models/CompanySite';
import JobCategory from 'models/JobCategory';

import { LIST_MARKUP } from 'consts/redux';

import { single as singleCmsPage } from 'requests/cmsPages';
import { list as listCompanySites } from 'requests/companySite';
import { list as listJobCategories } from 'requests/jobCategories';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let companies: ListCollection<CompanySite> = null;
    let jobCategories: ListCollection<JobCategory> = LIST_MARKUP;
    let notFound: boolean = null;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([

            listJobCategories({ page: 1, perPage: 99 }),

            listCompanySites({
                page: 1, perPage: 9,
                ...appContext?.query,
                search: appContext?.query?.search?.toString(),
                jobCategorySlugs: appContext?.query?.jobCategorySlugs?.toString().split(','),
            }),

            singleCmsPage({ slug: 'companysites' }),
        ]).then(responses => {
            jobCategories = responses[0];
            companies = responses[1];
            cmsPage = responses[2];
        });
    } catch (error) {
        console.error(error);
        notFound = true;
    }

    return {
        companies: companies || null,
        jobCategories: jobCategories.elements || null,
        notFound,
        cmsPage: cmsPage || null,
        initialSearchParams: appContext?.query,
    };
};

export default Component;
